<template>
    <small :class="classList">
        <slot />
    </small>
</template>

<script>
    import { VARIANTS } from './utils/variants';

    export default {
        name: 'C1HelpText',

        props: {
            variant: {
                type: String,
                default: null,
                validator: value => VARIANTS.includes(value),
            },
        },

        computed: {
            classList() {
                return [
                    this.getDefaultClass,
                    this.getTextColorClass,
                ];
            },

            getDefaultClass() {
                return 'af-help-text afu-block afu-mt-1';
            },

            getTextColorClass() {
                return this.variant ? `afu-text-${this.variant}-400` : '';
            },
        },
    };
</script>
